import React from 'react';
import { find, propEq, prop, pipe } from 'ramda';
import { withState } from 'recompose';
import Table from './Table';

const getNameByCode = code => pipe(
    find(propEq('code', code)),
    prop('name'),
);

const RegionRestrictionList = ({ 
    title, 
    restrictionName, 
    restrictionRegionName,
    regions, 
    regionList, 
    tableHeaderLabel, 
    selectedRegionCode, 
    setSelectedRegionCode, 
    removeRestriction, 
    addRestriction,
}) => {

    const activeRegionCode = selectedRegionCode || regionList[0].code; // Default to the first option in the list

    const columns = [
        {
            renderHeader: () => 'Actions',
            renderCell: ({ item: regionCode }) => (
                <button className="btn-icon danger" onClick={() => removeRestriction({ restrictionName, restrictionRegionName, regionCode })}>
                    <span className="glyphicon glyphicon-trash" />
                </button>
            ),
            size: '1px',
        },
        { 
            propertyName: 'name',
            renderHeader: () => tableHeaderLabel,
            renderCell: ({ item: code }) => getNameByCode(code)(regionList),
        },
    ];

    return (
        <div className="region-restriction-list">
            <strong>{ title }</strong>
            <div className="flex margin-top">
                <select value={activeRegionCode} onChange={({ target }) => setSelectedRegionCode(target.value)}>
                    {
                        regionList.map(region => (
                            <option 
                                key={region.code} 
                                value={region.code}
                            >
                                {region.name}
                            </option>
                        ))
                    }
                </select>
                <button 
                    className="btn btn-sm btn-success add-restriction" 
                    onClick={() => addRestriction({ 
                        restrictionName, 
                        restrictionRegionName, 
                        regionCode: activeRegionCode,
                    })}
                >
                    Add
                </button>
            </div>
            <Table
                className="table margin-top"
                columns={columns}
                items={regions}
            />        
        </div>
    );
};

export default pipe(
    withState('selectedRegionCode', 'setSelectedRegionCode', ''),
)(RegionRestrictionList);
